<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import Grid from '../components/Shared/Grid'
const moment = require('moment')

export default {
  name: 'ClassList',
  components: {
    Grid
  },
  data () {
    return {
      module: this.$route.meta.module,
      moment: moment,
      selectedClass: null,
      selectedClasses: [],
      pagination: {
        rowsNumber: 0,
        rowsPerPage: 10,
        page: 1,
        descending: true,
        sortBy: 'CLASS_START_DATE'
      },
      columns: [
        { name: 'CLASS_ID', label: 'Class ID', field: 'CLASS_ID', sortable: true, filterable: false, type: 'number', align: 'left' },        
        { name: 'CODE', label: 'Code', field: 'CODE', sortable: true, filterable: false, type: 'string', align: 'left' },
        { name: 'CLASS_START_DATE', label: 'Start Date', field: 'CLASS_START_DATE', sortable: true, filterable: false, type: 'date', align: 'left' },
        { name: 'CLASS_END_DATE', label: 'End Date', field: 'CLASS_END_DATE', sortable: true, filterable: false, type: 'date', align: 'left' },
        { name: 'LK_CLASS_STATUS_ID', label: 'Status', field: 'LK_CLASS_STATUS_ID', sortable: true, filterable: false, type: 'string', align: 'center' },
        { name: 'LK_CLASS_APPROVAL_STATUS_ID', label: 'Approval Status', field: 'LK_CLASS_APPROVAL_STATUS_ID', sortable: true, filterable: false, type: 'string', align: 'center' },
        { name: 'DATE_CREATED', label: 'Date Created', field: 'DATE_CREATED', sortable: true, filterable: false, type: 'date', align: 'left' }
      ],
      instructorFilter: '',
      currentInstructorLabel: '',
      affiliateFilter: '',
      currentAffiliateLabel: ''
    }
  },
  computed: {
    ...mapGetters('classes', [
      'classStatuses',
      'classApprovalStatuses'
    ]), 
    ...mapState({
      classList: (state) => state.classes.classList,
      loadingData: state => state.classes.loadingData,
      classId: s => s.classes.classId,
      searchFields: s => s.classes.searchFields,
      courses: s => s.students.courses,
      includeExpiredClasses: s => s.classes.includeExpiredClasses,
      includeInactiveAffiliates: s => s.classes.includeInactiveAffiliates,
      searchAffiliates: s => s.classes.searchAffiliates,
      instructors: s => s.classes.instructors,
      orderStatuses: s => s.shared.orderStatuses.map(s => ({
        label: s.STATUS, value: s.LK_ORDER_STATUS_ID,
      }))
    }),
    // Check to see if the user is JUST a recruiter
    onlyIsRecruiter () {
      let vm = this
      return vm.$p(['RECRUITER']) && !vm.$p(['ADMIN', 'MANAGER', 'AFFILIATE', 'INSTRUCTOR'], 'or')
    },
    isApprovedInstructor () {
      let isInstructor = this.$p(['INSTRUCTOR'])
      if (isInstructor) return this.currentUser().APPROVED_INSTRUCTOR
      return true
    }
  },
   created: function () {
    let vm = this
    vm.$root.$on('reloadClassDetailsModal', () => {
      let id = vm.classId
      vm.one({
        id: id,
        mode: id === "" || id === null ? "add" : "edit",
        newClass: false,
        sessionId: undefined
      })
    })
    vm.loadAffiliatesForSearch()
    vm.$store.dispatch('courses/fetchCourses')
    vm.setAffiliateSearch()
    vm.setInstructorSearch()
  },
    
  methods: {
    ...mapActions('classes', [
      'fetchClasses',
      'exportExcel',
      'one',
      'expandClass',
      'loadAffiliatesForSearch',
      'instructorAutocomplete',
      'affiliateAutocomplete'
    ]),
    ...mapMutations('classes', [
      'updateSelectedClasses',
      'updateAddEditClassOpenState',
      'updateModalMode',
      'updateModalLoading',
      'updateSessionInformation',
      'updateSelectedSession',
      'resetSearchFields',
      'setScheduleUploadOpen',
      'setInstructorSearch',
      'setAffiliateSearch',
      'setIncludeExpiredClasses',
      'setIncludeInactiveAffiliates'
    ]),
    async select (e, session_id) {
      let vm = this
      let id = e.CLASS_ID
      let mode = e && e.CLASS_ID ? "edit" : "add"
      vm.one({
        id: e.CLASS_ID,
        mode: id === "" ? "add" : "edit",
        newClass: (mode === 'add'),
        sessionId: session_id
      })
    },
    resetAndSearch () {
      let vm = this
      vm.instructorFilter = ''
      vm.currentInstructorLabel = ''
      vm.affiliateFilter = ''
      vm.currentAffiliateLabel = ''
      vm.resetSearchFields()
      vm.search()
    },
    search () {
      let vm = this
      vm.$root.$emit('refreshGrid:classListGrid')
    },
    scheduleUpload () {
      this.setScheduleUploadOpen(true)
    },
    getClassExpanded (idx) {
      return this.classList[idx]
    },
    onSelectInstructor (selectedInstructor) {
      let vm = this
      vm.setInstructorSearch(selectedInstructor)
      vm.currentInstructorLabel = selectedInstructor ? selectedInstructor.value : null
      setTimeout(function () {
        vm.search()
      }, 15)
    }, 
    async onInstructorAutocomplete (s, done) {
      let vm = this
      let results = await this.instructorAutocomplete(s)
      console.log(results)

      vm.currentInstructorLabel = (results.length == 0 && !vm.currentInstructorLabel) ? 'No Matching Instructors' : vm.currentInstructorLabel
      done(results)
    },
    onSelectAffiliate (selectedAffiliate) {
      let vm = this
      vm.setAffiliateSearch(selectedAffiliate)
      vm.currentAffiliateLabel = selectedAffiliate ? selectedAffiliate.value : null
      console.log(selectedAffiliate)
      if (selectedAffiliate && !selectedAffiliate.item.ACTIVE_IND ) {
        vm.setIncludeInactiveAffiliates(true)
      }
      else { 
        vm.setIncludeInactiveAffiliates(false)
      }
      setTimeout(function () {
        vm.search()
      }, 15)
    }, 
    async onAffiliateAutocomplete (s, done) {
      let vm = this
      let results = await this.affiliateAutocomplete({ search: s, scope: 'CLASS_ADVANCED_SEARCH' })
      vm.currentAffiliateLabel = (results.length == 0 && !vm.currentAffiliateLabel) ? 'No Matching Affiliates' : vm.currentAffiliateLabel
      done(results)
    }
  },
  watch: {
    'searchFields.LK_CLASS_STATUS_ID': function (newVal, oldVal) {
      const vm = this
      if (!!newVal) {
        vm.setIncludeExpiredClasses(false)
      }
    }    
  }
}
</script>

<template>
  <q-page class="stretch-grid has-search" :class="{'no-footer': onlyIsRecruiter && !isApprovedInstructor}">
    <q-collapsible class="search-box" collapse-icon="fa fa-angle-down">
      <template slot="header" class="search-box">
        <h5 style="padding: 12px 0px 12px 13px;width: 100%;">
          <q-icon name="fa fa-search" color="primary" style="padding:0 5px 3px" />Class Search
        </h5>
      </template>
      <form v-on:submit.prevent="">
        <!-- All -->
        <div id="classSearchTop" class="sl-row" style="padding:0 30px 5px; margin: 0">

          <div class="sl-row no-margin">
            <div class="sl-col-4">
              <q-input float-label="Class ID" v-model="searchFields.CLASS_ID"
                clearable 
                @clear="search()" 
                />
            </div>
            <div class="sl-col-4">
              <q-field :helper="currentInstructorLabel">
                <q-input float-label="Instructor" :clear-value="null" clearable @clear="onSelectInstructor()" v-model="instructorFilter">
                  <q-autocomplete                      
                    :debounce="500"
                    float-label="Instructor"
                    :max-results="10"
                    @search="onInstructorAutocomplete"
                    @selected="onSelectInstructor"
                  />
                </q-input>
              </q-field>
            </div>            
            <div class="sl-col-4"><q-input float-label="Address 1" v-model="searchFields['~ADDRESS_1']"/></div>       
          </div>

          <div class="sl-row no-margin">
            <div class="sl-col-4">
              <q-datetime
                clearable
                v-model="searchFields['CLASS_START_DATE']"
                :before="[{icon: 'calendar_today' }]"
                @clear="search()"
                type="date"
                format="MM/DD/YYYY"
                float-label="Start Date"
                popover
              /> 
            </div>
            <div class="sl-col-4">
              <q-datetime
                clearable
                v-model="searchFields['CLASS_END_DATE']"
                :before="[{icon: 'calendar_today' }]"
                type="date"
                format="MM/DD/YYYY"
                float-label="End Date"
                popover
                @clear="search()"
              />
            </div>
            <div class="sl-col-4">
              <q-select
                clearable
                float-label="Course"
                :options="courses"
                v-model="searchFields.COURSE_ID"
                @clear="search()"
              />            
            </div>
          </div>

          <div class="sl-row no-margin">
            <div class="sl-col-4">
              
              <q-field :helper="currentAffiliateLabel">
                <q-input float-label="Affiliate" :clear-value="null" clearable @clear="onSelectAffiliate()" v-model="affiliateFilter">
                  <q-autocomplete                      
                    :debounce="500"
                    float-label="Affiliate"
                    :max-results="10"
                    @search="onAffiliateAutocomplete"
                    @selected="onSelectAffiliate"
                  />
                </q-input>
              </q-field>  
            </div>            
            <div class="sl-col-4">
              <q-select
                clearable
                float-label="Class Status"
                :options="classStatuses"
                v-model="searchFields['LK_CLASS_STATUS_ID']"
                @clear="search()"
              /> 
            </div>
            <div class="sl-col-4" style="padding-top:20px">
              <q-checkbox :disable="!!searchFields['LK_CLASS_STATUS_ID']" :value="includeExpiredClasses" @input="v => setIncludeExpiredClasses(v)" label="Include Expired Classes" />
              <q-checkbox :value="searchFields['INCLUDE_INACTIVE_AFF']" @input="v => setIncludeInactiveAffiliates(v)" label="Include Inactive Affiliates" />
            </div> 
          </div>

          <div class="sl-row no-margin">
            <div class="sl-col-4">
              <q-select
                clearable
                float-label="Payment Status"
                :options="orderStatuses"
                v-model="searchFields['PAYMENT_STATUS']"
                @clear="search()"
              />
            </div>
          </div>
        </div>


        <q-toolbar color="white" style="padding-right:60px">
          <q-toolbar-title></q-toolbar-title>
          <q-btn color="secondary" label="Clear" outline size="sm" type="reset" style="margin-right:5px" @click="resetAndSearch"/> 
          <q-btn color="primary" label="Search" size="sm" type="submit" @click="search()" />
        </q-toolbar>
      </form>
    </q-collapsible>

    <Grid
      id="classListGrid"
      :expandable="true"
      :module="module"
      :data="classList"
      :columns="columns"
      :pagination="pagination"
      :onRequest="fetchClasses"
      :onLaunch="select"
      :onExport="fetchClasses"
      :onExpand="expandClass"
      :loading="loadingData"
      :rowsPerPageOptions="[10,20,30,50,100]">
      <template slot="col-item-date_created" slot-scope="props">
        {{ moment(props.value,"YYYY-MM-DD hh:mm:ss").format('LL') }}
      </template>
      <template slot="col-item-instructors" slot-scope="props">
        {{ props.value.length }}
        <q-tooltip v-if="props.value.length > 0">
          <ul>
            <li v-for="ins in props.value" v-bind:key="ins.INSTRUCTOR_ID">{{ ins.FIRST_NAME }} {{ ins.LAST_NAME }}</li>
          </ul>
        </q-tooltip>
      </template>
      <template slot="col-item-class_start_date" slot-scope="props">
        {{ moment(props.value,"YYYY-MM-DD HH:mm").utc().format("MMMM Do, YYYY h:mm A") }}
      </template>
      <template slot="col-item-class_end_date" slot-scope="props">
        {{moment(props.value,"YYYY-MM-DD HH:mm").utc().format("MMMM Do, YYYY h:mm A") }}
      </template>
      <template slot="col-item-students" slot-scope="props">
        {{ props.value }}
      </template>
      <template slot="col-item-lk_class_status_id" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
          class="label"
          :class="{
            'blue'  : props.value == 'SCHEDULED',
            'green' : props.value =='ACTIVE' || props.value =='APPROVED' || props.value == 'COMPLETED',
            'purple': props.value == 'PROCESSED',
            'red'   : props.value =='CANCELLED',
            'yellow': props.value =='HELD'
          }">
          {{props.value}}
        </div>
      </template>
      <template slot="col-item-lk_class_approval_status_id" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
          class="label"
          :class="{
            'blue'  : props.value == 'SUBMITTED' || props.value == 'RESUBMITTED',
            'green' : props.value =='APPROVED',
            'red'   : props.value =='REJECTED',
            'yellow': props.value =='EXPIRED'
          }">
          {{props.value}}
        </div>
      </template>
      <template slot="col-item-date_created" slot-scope="props">
        <q-icon name="cloud_upload" color="green" v-if="classList[props.index].UPLOADED_IND" /> {{moment(props.value).format("MMMM DD, YYYY")}}
      </template>
      <template slot="col-item-expand" slot-scope="props">
        <div class="relative-position" style="min-height:150px">
          <q-inner-loading :visible="classList[props.props.key].loading">
            <q-spinner-puff color="primary" size="70"></q-spinner-puff>
            <span>Loading Sessions..</span>
          </q-inner-loading>
          <div class="sessions-table" v-if="props.props.row.SESSIONS.length">
            <div class="sl-row table-head">
              <div class="sl-col-9">
                Sessions
              </div>
            </div>
            <div class="sl-row table-columns">
              <div class="sl-col-1">
                View
              </div>
              <div class="sl-col-2">
                Start Date
              </div>
              <div class="sl-col-2">
                End Date
              </div>
              <div class="sl-col-1">
                Students
              </div>
              <div class="sl-col-1">
                Instructors
              </div>
              <div class="sl-col-2">
                Location
              </div>
            </div>
            <div class="sl-row" v-for="session in props.props.row.SESSIONS" v-bind:key="session.SESSION_ID">
              <div class="sl-col-1 row-actions">
                <q-btn @click="select(props.props.row, session.SESSION_ID)" icon="fa fa-external-link" outline color="primary">
                  <q-tooltip anchor="bottom middle" self="top middle" :offset="[10, 10]">View</q-tooltip>
                </q-btn>
              </div>
              <div class="sl-col-2">
                {{ moment(session.START_DATE).format("MMMM Do, YYYY h:mm A") }}
              </div>
              <div class="sl-col-2">
                {{ moment(session.END_DATE).format("MMMM Do, YYYY h:mm A") }}
              </div>
              <div class="sl-col-1">
                {{ session.STUDENT_COUNT }}
              </div>
              <div class="sl-col-1">
                {{ session.INSTRUCTOR_COUNT }}
              </div>
              <div class="sl-col-2">
                {{ session.LOCATION }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </Grid>
  
    <q-layout-footer v-if="!onlyIsRecruiter && isApprovedInstructor">
      <q-toolbar>
        <q-toolbar-title>
        </q-toolbar-title>
        <q-btn
          label="Upload"
          icon="cloud_upload"
          color="green"
          outline          
          @click="scheduleUpload()">
          </q-btn>&nbsp;
        <q-btn
          label="New"
          icon="add"
          color="primary"
          @click="select({})">
        </q-btn>
      </q-toolbar>
    </q-layout-footer>   
  </q-page>
</template>

<style lang="stylus">
  .sessions-table {
    padding 20px 0
    .sl-row {
      border-bottom: 1px solid rgba(0,0,0,0.12)

      &:last-child {
        border-bottom: 0;
      }

      &.table-head {
        margin-bottom 0
        div {
          padding-top: 5px;
          padding-bottom: 10px;
          font-weight: 500;
          font-size: 15px;
        }
      }

      &.table-columns {
        padding-top 10px
        background #e4e4e4
        div {
          padding-bottom: 10px;
        }
      }

      div {
        text-align: center;
      }

      .q-btn {
        margin-top: -10px;
        margin-bottom: 10px;
      }
    }
  }
</style>
